import useTenant from 'hooks/useTenant';

const TenantAuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isLoading, error } = useTenant();

  if (isLoading) return null;
  if (error) return null;

  return <>{children}</>;
};

export default TenantAuthWrapper;
